/* @flow */
/**
 *
 * @typedef { Object } Service
 * @memberof ServiceService
 */
import _ from 'lodash'
import Typenames from './Typenames'
import { ActionTypes, store } from 'store'

export type Service = {
  name: string,
  version?: string,
  serviceType: string,
  serviceConfiguration: Object
}

const TYPENAME = Typenames.SERVICE

const serviceTypes = (): Array<Object> => {
  const omittedServices = _.split((window.env && window.env['CUESTA_OMITTED_SERVICES']) || '', ',')
  return _.filter(
    [
      //{ name: 'WEBHOOK', icon: 'globe' },
      { name: 'MAIL', icon: 'mail', canTrigger: true },
      { name: 'SERIALPORT', icon: 'microchip', canTrigger: true },
      { name: 'MQ', icon: 'sitemap', canTrigger: true },
      { name: 'CHAT', icon: 'chat', canTrigger: true }
    ],
    s => !_.find(omittedServices, os => os === s.name)
  )
}

/**
 * Creates a new service.
 * @function
 * @memberof ServiceService
 *
 * @return { Promise<string> } The id of the added service.
 */
const createService = (service: Service): Promise<PostResponse> => {
  return store.dispatch(ActionTypes.CREATE, { typename: TYPENAME, item: service })
}

/**
 * Reads a Service, flattening 'descriptive'.
 * @function
 * @memberof ServiceService
 *
 * @return { Promise<Service> } The service.
 */
const readService = (id: string): Promise<Service> => {
  return store.dispatch(ActionTypes.GET_BY_ID, { typename: TYPENAME, id: id })
}

/**
 * Updates a service.
 * @function
 * @memberof ServiceService
 *
 * @return { Promise<any> }
 */
const updateService = (id: string, service: Service): Promise<PostResponse> => {
  return store.dispatch(ActionTypes.UPDATE, { typename: TYPENAME, id: id, item: service })
}

/**
 * Deletes a service.
 * @function
 * @memberof ServiceService
 *
 * @return { Promise<any> }
 */
const deleteService = (id: string): Promise<any> => {
  return store.dispatch(ActionTypes.DELETE, { typename: TYPENAME, id: id })
}

/**
 * Reads all services, flattening descriptive.
 * @function
 * @memberof ServiceService
 *
 * @return { Promise<Array<Service>> } All the services.
 */
const readAllServices = (): Promise<Array<Service>> => {
  return store.dispatch(ActionTypes.GET, TYPENAME)
}

const self = {
  createService,
  readService,
  updateService,
  deleteService,
  readAllServices,
  serviceTypes
}

/**
 * Service service: CRUD interface for services.
 * @module ServiceService
 * @namespace ServiceService
 * @version 1.0.0
 */
export default self
